import React from 'react'
import { useNavigate } from 'react-router-dom'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import { Button } from '@mui/material'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
import { GetAllGlobalUsersDetails } from 'types/api/faber/globalCustomers.type'
import { GetAllFaberUsersDetails } from 'types/api/faber/oneTimePack.type'
import { SubscriptionsTableRows } from 'types/api/faber/subscription.type'

interface ViewProfileProps {
  customerRow:
    | SubscriptionsTableRows
    | GetAllFaberUsersDetails
    | GetAllGlobalUsersDetails
}
export function ViewExternalProfileButton({ customerRow }: ViewProfileProps) {
  const navigate = useNavigate()

  const handleViewProfilePage = () => {
    //for Otpack customers
    if ('_id' in customerRow) {
      if (customerRow.subscription) {
        navigate(
          //subscription users - will reroute back to subscription
          `/hq/manage-customers-faber/view-external-profile/${customerRow?._id}`,
          {
            state: customerRow
          }
        )
      } else {
        //otpack only
        navigate(`view-external-profile/${customerRow?._id}`, {
          state: customerRow
        })
      }
    } else if ('userID' in customerRow) {
      //subscription users
      navigate(`view-external-profile/${customerRow.userID}`, {
        state: customerRow
      })
    } else {
      navigate(`view-external-profile/${customerRow.user_id}`, {
        state: customerRow
      })
    }
  }

  return (
    <>
      <Button
        sx={{
          backgroundColor: circlesOrbitColorPalette.primary.disabled,
          borderColor: circlesOrbitColorPalette.text.light,
          borderWidth: 0.5,
          ':hover': {
            backgroundColor: circlesOrbitColorPalette.primary.dark
          }
        }}
        onClick={handleViewProfilePage}
      >
        <ManageAccountsIcon
          sx={{ color: circlesOrbitColorPalette.neutrals[0] }}
        />
      </Button>
    </>
  )
}
